<script lang="ts" setup>
const props = defineProps<{
  name: string
  thumbsDirection?: 'horizontal' | 'vertical'
  thumbsTrigger?: 'click' | 'mouseover'
}>()

const {
  galleryItems,
  galleryOptions,
  activeItem,
  setItem,
  // gallery,
  getImageFromProvider,
} = useUiMediaGallery(props.name)

const { open: openFullscreen } = useUiDialog('media-gallery')

const thumbs = useTemplateRef('thumbs-desktop')
const scrollableThumbs = ref(false)

const showMore = ref(false)

function onClick(index: number) {
  setItem(index, galleryOptions.value.behavior)
  openFullscreen()
}

const targetIsVisible = useElementVisibility(thumbs)

function checkScrollablity() {
  scrollableThumbs.value = (thumbs.value?.scrollWidth || 0) > (thumbs.value?.clientWidth || 0)
}

watchEffect(() => {
  if (targetIsVisible.value) {
    checkScrollablity()
  }
})

onMounted(() => {
  checkScrollablity()
})
</script>

<template>
  <div
    class="media-gallery-grids"
  >
    <div
      ref="thumbs-desktop"
      class="media-gallery-grids__container"
      :class="{
        'media-gallery-grids__container--show-more': showMore,
      }"
    >
      <template v-if="galleryItems.length > 0" >
        <button
          v-for="item in galleryItems"
          :key="item.src"
          type="button"
          :data-thumb="item.index"
          class="media-gallery-grids__thumb"
          :class="{
            'media-gallery-grids__thumb--active': activeItem?.src === item.src,
          }"
          @click="onClick(item.index)"
        >
          <UiVideo
            v-if="item.type === 'video'"
            :src="item.src"
            width="650"
            height="480"
            class="media-gallery-grids__video"
            :controls="false"
          />
          <img
            v-else-if="item.type === 'image'"
            :src="getImageFromProvider(item, { width: 650, height: 480 })"
            :alt="item.alt"
            width="650"
            height="480"
            loading="lazy"
            class="media-gallery-grids__image"
          >
        </button>
      </template>
    </div>

    <button
      v-if="galleryItems && galleryItems.length > 5"
      type="button"
      class="media-gallery-grids__more"
      @click="showMore = !showMore"
    >
      <span v-if="!showMore">{{ $t('Show more') }}</span>
      <span v-else>{{ $t('Show less') }}</span>
    </button>
  </div>
</template>

<style>
@import url("~layers/app/components/Ui/MediaGallery/Grids.css");
</style>
